<template>
  <!-- <v-card height="350px"> -->
  <v-navigation-drawer :class="{
    'side-menu-container': true,
    A: side === 'A',
    B: side === 'B',
    'no-max-height': this.$store.getters.isMobile,
  }" width="100%" permanent color="blue lighten-5" ref="navDrawer" id="nav-drawer">
    <template v-slot:prepend>
      <SideHeader :side="side" :sideColor="sideColor" :stateWideDistrictTypeData="stateWideDistrictTypeData"
        :isFinal="litigation === null" />
    </template>

    <v-divider v-show="side === 'B'"></v-divider>
    <v-tabs color="blue" background-color="blue lighten-5" :class="{ hidden: side === 'B', 'legend-items': true }"
      dense>
      <v-tab class="tab-btn" v-show="side === 'A'">
        <v-icon left> mdi-table-multiple </v-icon>
        Data
      </v-tab>
      <v-tab class="tab-btn" v-show="side === 'A'">
        <v-icon left> mdi-map-legend </v-icon>
        Legend
      </v-tab>

      <v-tab-item class="blue lighten-5 side-content-container">
        <v-divider :class="{ hidden: side === 'B' }"></v-divider>
        <v-list-item class="v-list-item-p12 under-sticky">
          <v-list-item-content>
            <div v-if="selectedDistrictData && Object.keys(selectedDistrictData).length > 0">
              <div>
                <v-alert border="left" dense colored-border color="info" elevation="2" class="text-body-1">
                  <!--                   <span>
                    <i class="fas fa-map-marker-alt" style="color:#0089FB;"></i>&nbsp;The location you've selected is in <b v-bind:style="{ color: sideColor }">{{ stateWideDistrictTypeData.displayname }} district {{ selectedDistrictData.districtid }}</b>, from the <em>{{ perProposalData.displayname }}</em> plan submitted by <a v-bind:href="perProposalData.submitterurl" target="_blank">{{ perProposalData.submittername }}</a> on {{ perProposalData.submitteddate }}.
                    <div v-if="perProposalData.tags" class="my-2" v-bind:style="{ color: sideColor }">
                       {{ selectedDistrictData.mapnotes }}
                      <b>{{ perProposalData.notes }}</b>
                    </div>
                  </span> -->
                  <span>
                    <!-- {{ selectedDistrictData.namelsad }} -->
                    <i class="fas fa-map-marker-alt" style="color:#0089FB;"></i>&nbsp;The location you've selected is in
                    {{
                      selectedDistrictData.statename }}'s <b v-bind:style="{ color: sideColor }">{{ activeDistrictTypeName
                      }}
                      {{
                        selectedDistrictData.districtid }}</b> that was adopted <b v-bind:style="{ color: sideColor }">{{
                        selectedDistrictData.mapnotes }}</b>.
                  </span>

                </v-alert>
              </div>

              <!--               <div v-show="side === 'A'">
                <p class="text-body-2">
                  The location you've selected is in the
                  <strong>{{ selectedDistrictData.namelsad }} in
                    {{ selectedDistrictData.statename }}</strong>, enacted after the 2010 Census.
                  <br />
                </p>
              </div> -->

              <p class="text-body-2" v-show="side === 'A'">Move the <em>slider</em> to the
                <i class="fas fa-long-arrow-alt-left"></i><em> left</em> to show <b
                  v-bind:style="{ color: sideColor }">District {{ selectedDistrictData.districtid }} ({{
                    perProposalData.displayname }})</b>. This district
                &amp;
                the one highlighted on the right are both displayed when the slider is midpoint.
              </p>
              <p class="text-body-2" v-show="side === 'B'">Move the <em>slider</em> to the <em>right </em>
                <i class="fas fa-long-arrow-alt-right"></i> to show <b v-bind:style="{ color: sideColor }">District {{
                  selectedDistrictData.districtid }} ({{
                    perProposalData.displayname }})</b>. This district
                &amp;
                the one highlighted on the left are both displayed when the slider is midpoint.
              </p>

              <div id="side-slider-container">
                <SideOpacitySlider />
              </div>

              <!--               <div v-show="(side === 'B' || hideCurrentDistrictsFromDropdown === false)
                ">
                <v-alert border="left" dense colored-border color="info" elevation="2" class="text-body-1">

                  <span v-if="selectedDistrictData.districtid === '00'">

                    <i class="fas fa-map-marker-alt" style="color:#0089FB;"></i>&nbsp;The location you've selected is in
                    {{
                    selectedDistrictData.statename }}'s
                    <strong>At-Large Congressional district</strong>.

                    <div v-show="litigation && side === 'B'" class="text-body-2">
                      <v-divider class="mt-1 mb-1"></v-divider>
                      <strong>NOTE:</strong> {{ litigation }} (per <em>All About Redistricting's</em> <a
                        href="https://redistricting.lls.edu/national-overview/?colorby=Institution&level=Congress&cycle=2020"
                        target="_blank">national overview</a>)
                    </div>
                  </span>
                  <span v-else>
                    <i class="fas fa-map-marker-alt" style="color:#0089FB;"></i>&nbsp;The location you've selected is in
                    {{
                    selectedDistrictData.statename }}'s
                    <strong><span>new {{ stateWideDistrictTypeData.displayname }}</span>
                      district {{ selectedDistrictData.districtid }}</strong>.

                    <div v-show="litigation && side === 'B'" class="text-body-2">
                      <v-divider class="mt-1 mb-1"></v-divider>
                      <strong>NOTE:</strong> {{ litigation }} (per <em>All About Redistricting's</em> <a
                        href="https://redistricting.lls.edu/national-overview/?colorby=Institution&level=Congress&cycle=2020"
                        target="_blank">national overview</a>)
                    </div>
                  </span>
                </v-alert>

                <div v-if="selectedDistrictData.districtid != '00'">
                  <span v-if="sameDistrict">
                    <v-alert dense dark shaped color="info" class="text-body-1">The {{
                      stateWideDistrictTypeData.displayname
                      }} district
                      number for this location ({{
                        selectedDistrictData.districtid
                      }}) is the same. But
                      <strong>the district lines have changed</strong>. Use the <v-icon>mdi-map</v-icon>
                      slider to compare:
                      <ul>
                        <li>
                          <strong>move the slider to the <i class="fas fa-long-arrow-alt-left"></i> left</strong> for
                          the
                          old
                          lines;
                        </li>
                        <li>
                          <strong>move it to the right <i class="fas fa-long-arrow-alt-right"></i></strong> for the new
                          ones.
                        </li>
                      </ul>
                    </v-alert>
                  </span>

                  <span v-else>
                    <v-alert dense dark shaped color="info" class="text-body-1"><strong>The
                        {{ stateWideDistrictTypeData.displayname }} district for
                        this location has changed.</strong>
                      Use the <v-icon>mdi-map</v-icon>
                      slider to compare:
                      <ul>
                        <li>
                          <strong>move the slider to the <i class="fas fa-long-arrow-alt-left"></i> left</strong> for
                          the
                          old
                          lines;
                        </li>
                        <li>
                          <strong>move it to the right <i class="fas fa-long-arrow-alt-right"></i></strong> for the new
                          ones.
                        </li>
                      </ul>
                    </v-alert>
                  </span>

                  <div id="side-slider-container">
                    <SideOpacitySlider />
                  </div>
                </div>
              </div> -->

              <RedistrictingMetricsTables :selectedDistrictData="selectedDistrictData"
                :stateWideDistrictTypeData="stateWideDistrictTypeData" />
              <DistrictPopTables :selectedDistrictData="selectedDistrictData"
                :stateWideDistrictTypeData="stateWideDistrictTypeData" />
              <PieChart :side="side" :districtData="selectedDistrictData"
                :legBody="this.$store.getters.getActiveDistrictType" />

            </div>

            <div v-else>
              <span>
                <div id="side-slider-container">
                  <SideOpacitySlider />
                </div>
                <br />
                <p class="text-body-1" v-show="side === 'A'">
                  Search by address, select a state/district from the list above, or click/tap the map to find your
                  district.
                  <br />
                  <br />
                  Move the <b>slider</b> to the <i class="fas fa-long-arrow-alt-left"></i><em> left</em> to show
                  <em>districts from the list above</em> (these districts &amp; the ones on the right are both displayed
                  when the slider is midpoint).
                </p>
                <p class="text-body-1" v-show="side === 'B'">
                  Search by address, select a state/district from the list above, or click/tap the map to find your
                  district.
                  <br />
                  <br />
                  Move the <b>slider</b> to the <em>right </em><i class="fas fa-long-arrow-alt-right"></i> to show
                  <em>districts from the list above</em> (these districts &amp; the ones on the left are both displayed
                  when
                  the slider is midpoint).
                </p>
              </span>
            </div>

            <!--           <div v-else>
              <p class="text-body-2" v-show="side === 'A'">
                Search by address, select a state &amp; district from the list above, or
                click/tap the map to find your "old" district (in effect after the 2010 Census).
                <br />
                <br />
                Move the <b>slider</b> to the <i class="fas fa-long-arrow-alt-left"></i><em> left</em> to show <em>districts from the list above</em> (these districts &amp; the ones on the right are both displayed when the slider is midpoint).
           
              </p>
              <p class="text-body-2" v-show="side === 'B' || hideCurrentDistrictsFromDropdown === false
                ">
                Search by address, select a state &amp; district from the list above, or
                click/tap the map to see how your district has changed.
                <br />
                <br />
                Move the <strong>slider</strong> to the <em>right </em>
                <i class="fas fa-long-arrow-alt-right"></i> to show
                <em>new districts approved after the 2020 Census</em> (old &amp;
                new districts are both displayed when the slider is midpoint).
              </p>
            </div> -->
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
      <v-tab-item class="blue lighten-5 side-legend-container">
        <v-divider></v-divider>
        <SideLegend class="under-sticky" />
      </v-tab-item>
    </v-tabs>
  </v-navigation-drawer>
  <!-- </v-card> -->
</template>
<script>
import SideHeader from "./SideHeader.vue";
import PieChart from "./PieChart.vue";
import DistrictPopTables from "./Tables/DistrictPopTables.vue";
import RedistrictingMetricsTables from "./Tables/RedistrictingMetricsTables.vue";
import { EventBus } from "../../js/DataManagement/EventBus";
import SideLegend from "./SideLegend";
import SideOpacitySlider from "../Controls/SideOpacitySlider.vue";
import _ from "lodash";
import $ from "jquery";

export default {
  name: "SideMenuContainer",
  props: ["side"],
  components: {
    SideHeader,
    DistrictPopTables,
    RedistrictingMetricsTables,
    PieChart,
    SideLegend,
    SideOpacitySlider
  },
  data: function () {
    return {
      items: [],
      perDistrictData: {},
      perProposalData: {},
      selectedDistrictId: null,
      selectedDistrictData: null,
      repData: null,
      items_props: [],
      selectedProposalTablename: {},
      selectedProposalId: "",
      litigation: null,
      updating: false
    };
  },
  mounted: function () {
    let self = this;

    if (this.$querystringManager.route.query[`prop${this.side}`]) {
      this.selectedProposalId =
        this.$querystringManager.route.query[`prop${this.side}`];
      this.$store.commit(
        `setSide${this.side}Proposal`,
        this.selectedProposalId
      );
    }

    this.$nextTick(() => {
      self.$map.once("idle", self.populateList);
    });

    EventBus.$on("force-populate-list", this.populateList);

    EventBus.$on('update-you-selected', (val) => {
      self.selectedDistrictData = self.selectedDistrictData || {}
      if (val.side === self.side) {
        self.selectedDistrictData.statename = val.state;
        self.selectedDistrictData.namelsad = val.text;
      }
    });
    EventBus.$on(`update-side-panel-${self.side}`, async (sideData) => {
      // {
      //   "geoid": "2204",
      //   "propid": "cong_current_all",
      //   "side": "A"
      // }
      if (self.updating) return;

      self.updating = true;
      self.repData = null;

      const currentTableName = sideData.propid

      self.perProposalData = self.$dataManager.getPerProposalData(currentTableName);
      self.selectedDistrictId = sideData.geoid;

      const response = await self.$dataManager.getSelectedDistrictData(sideData.propid, sideData.geoid)
      const districtData = response.data[0]
      self.selectedDistrictData = districtData
      self.$store.commit(`setSelectedDistrictSide${self.side}`, districtData.geoid);
      self.$forceUpdate();

      // self.getCurrentRepInfo();
      self.updating = false;
    });

    if (!this.forPrint) {
      this.syncScroll();
    }

    EventBus.$on("clearSidePanels", () => {
      self.selectedDistrictId = null;
      self.selectedDistrictData = null;
      self.repData = null;
      self.litigation = null;
    });
  },
  methods: {
    onChange: function () {
      // update all elements, then toggle map change
      this.$store.commit(
        `setSide${this.side}id`,
        this.selectedProposalTablename
      );
      const displayName = this.$layerManager.getLayerDisplayNameFromId(
        this.selectedProposalTablename
      );

      this.$store.commit(`setSide${this.side}DisplayName`, displayName);

      this.$layerManager.showProposal({
        _id: this.selectedProposalTablename,
        _side: this.side,
      });

      this.selectedProposalId = this.$layerManager.getProposalIdfromTableName(
        this.selectedProposalTablename
      );

      this.$querystringManager.addQueryParam(
        `prop${this.side}`,
        this.selectedProposalId
      );

      this.$store.commit(
        `setSide${this.side}Proposal`,
        this.selectedProposalId
      );

      // let self = this;
      // this.$nextTick(() => {
      //   const lnglat = self.$store.getters.getSelectedLngLat;
      //   if (lnglat.length > 1) {
      //     EventBus.$emit("select-from-proposal-switch", lnglat);
      //   }
      // });
    },
    populateList: function () {
      let self = this;
      //console.log("pop list");
      //this.$nextTick(() => {
      self.items = self.$layerManager
        .getLayerDisplayNamesIDsPair(self.$store.getters.getActiveDistrictType)
        .map((l) => {
          return {
            text: l.name,
            value: l.id,
          };
        });
      //Set defaults

      this.selectedProposalId =
        this.$store.getters[`getSide${this.side}Proposal`];

      if (!this.selectedProposalId || this.selectedProposalId.length === 0) {
        let prop = self.$layerManager.getDefaultLayerForSide(
          self.side,
          self.$store.getters.getActiveDistrictType
        );
        self.selectedProposalId = prop ? prop.proposal_id : "";
      }

      self.selectedProposalTablename =
        self.$layerManager.getTableNameFromIdandDistrictType(
          this.selectedProposalId,
          self.activeDistrictType
        );
    },
    selectDistrictOnMapFromLatLng() { },
    currentJurisictionTypeIs(_type) {
      if (!this.perProposalData || !this.perProposalData.tags) return false;
      let tags = this.perProposalData.tags.replace(" ", "").split(",");
      return tags.includes(_type);
    },
    getCurrentRepInfo() {
      if (this.side !== "A") return;
      let type = this.$store.getters.getActiveDistrictType;
      const stateAbbrev = this.selectedDistrictData.stusps.toLowerCase();
      let id =
        this.selectedDistrictData.osid || this.selectedDistrictData.districtid;

      this.$dataManager.getRepData(stateAbbrev, id, type).then((data) => {
        if (data) {
          this.repData = data;
        }
      }).catch(() => this.repData = null);
    },
    throttleSetScroll: _.debounce((el, _scrollTop) => {
      el.scrollTop = _scrollTop;
    }, 10),
    syncScroll() {
      if (this.$vuetify.breakpoint.name === "xs") return;
      let self = this;

      //Sync Scroll
      $(`.side-menu-container.${this.side} .v-navigation-drawer__content`).on(
        "scroll",
        function (e) {
          EventBus.$emit(
            `scroll-side-${self.side}`,
            e.target.scrollTop // e.target.scrollHeight
          );
        }
      );

      let otherside = self.side === "A" ? "B" : "A";

      EventBus.$on(`scroll-side-${otherside}`, (_scrollTop) => {
        $(
          `.side-menu-container.${self.side} .v-navigation-drawer__content`
        ).each((i) => {
          //console.log(this)
          self.throttleSetScroll(
            $(
              `.side-menu-container.${self.side} .v-navigation-drawer__content`
            )[i],
            _scrollTop
          );
        });
      });
    },
    updateLitigation() {

      let type = this.$store.getters.getActiveDistrictType;
      let statefips = this.$store.getters.getSelectedState;
      //console.log(this.$litigationStatuses)
      const _checkStatus = this.$litigationStatuses.filter((_status) => {
        return _status.jurisdiction === type && +_status.statefips === +statefips;
      });
      // console.log(_checkStatus)

      if (_checkStatus && _checkStatus.length && _checkStatus.length > 0) {
        this.litigation = _checkStatus[0].litigation.length > 0 ? _checkStatus[0].litigation : null;
      } else {
        this.litigation = null;
      }
    },
  },
  watch: {
    activeDistrictType: function () {
      this.populateList();
    },
    selectedProposalTablename: function () {
      this.onChange();
    },
    proposalId: function (val) {
      let self = this;
      if (!val) {
        this.$nextTick(() => {
          let prop = self.$layerManager.getDefaultLayerForSide(
            self.side,
            self.$store.getters.getActiveDistrictType
          );
          const _proposalId = prop ? prop.tablename : "";

          self.$store.commit(`setSide${this.side}id`, _proposalId);
        });
      } else {
        this.perProposalData = this.$dataManager.getPerProposalData(val);
      }
    },
    selectedDistrictId: function () {
      this.repData = null;
      if (!this.selectedDistrictData) return;

      //this.getCurrentRepInfo();

      this.$store.commit(
        `setSelectedDistrictSide${this.side}`,
        this.selectedDistrictData.geoid
      );
    },
    stateWideDistrictTypeData: function () {
      this.updateLitigation();
    },
    "$store.getters.getSelectedState": function () {
      this.updateLitigation();
    },
  },
  computed: {
    activeDistrictType: function () {
      return this.$store.getters.getActiveDistrictType;
    },
    activeDistrictTypeName: function () {
      const districtTypes = [
        { label: "Congressional District", value: "cd" },
        { label: "State Leg. Lower House District", value: "ad" },
        { label: "State Leg. Upper House District", value: "sd" },
      ]

      return districtTypes.find(d => d.value === this.activeDistrictType)?.label ?? 'District';
    },
    proposalId: function () {
      return this.$store.getters[`getSide${this.side}id`];
    },
    sideColor: function () {
      return `#${this.perProposalData.mapcolor ||
        this.$styleConfig.styles.outlines.paint[`Prop-${this.side}`][
          "line-color"
        ].replace("#", "")
        }`;
    },
    hideCurrentDistrictsFromDropdown: function () {
      return this.$mainConfig.hideCurrentDistrictsFromDropdown;
    },
    sameDistrict: function () {
      const otherSide = this.side === "A" ? "B" : "A";

      return (
        this.selectedDistrictData.geoid ===
        this.$store.getters[`getSelectedDistrictSide${otherSide}`]
      );
    }, stateWideDistrictTypeData: function () {
      // console.log('swdts')
      let type = this.$store.getters.getActiveDistrictType;

      const distIdMap = {
        cd: "cong_avg",
        ad: "sldl_avg",
        sd: "sldu_avg",
      };

      if (
        !this.$store.getters[`getSelectedDistrictSide${this.side}`] ||
        this.$store.getters[`getSelectedDistrictSide${this.side}`].length === 0
      )
        return {};

      const stateFips = this.$store.getters[
        `getSelectedDistrictSide${this.side}`
      ].substring(0, 2);
      if (!stateFips || stateFips.length === 0) return {};
      //console.log(stateFips)
      const avgpops = this.$stateData.states.filter((s) => {
        return +s.statefips === +stateFips;
      })[0];

      if (!avgpops || avgpops[distIdMap[type]] === 0) return {};

      const displayname = this.$mainConfig.state["body-display-names"];

      return {
        displayname: displayname[type],
        avgpop: parseFloat(avgpops[distIdMap[type]]).toLocaleString(),
      };
    },
  },
};
</script>
<style>
.subtitle-container {
  position: relative;
  top: -30px;
}

.subtitle-container .subtitle {
  position: absolute;
  font-size: 0.75em;
  top: 7%;
  margin: 0.5em;
}

.subtitle-container .subtitle.right {
  transform: none;
  /* width: -webkit-max-content; */
  width: -moz-max-content;
  /* width: max-content; */
  line-height: 1.1em;
  /* min-width: 50%; */
  /* width: 50%; */
  max-width: 50%;
  right: 0;
}
</style>
<style>
.side-menu-container {
  overflow-y: hidden;
  max-height: calc(100vh - 64px);
}

.text-caption-sidea {
  font-size: 0.75rem !important;
  font-weight: 400;
  line-height: 1.25rem;
  color: rgba(0, 0, 0, 0.6);
  /* letter-spacing: 0.0333333333em !important; */
  /* font-family: "Roboto", sans-serif !important; */
}

.side-menu-container .v-list-item__content>div {
  max-width: 100%;
}

.side-menu-container .v-navigation-drawer__content {
  overflow-y: scroll;
}

.v-list-item-p12 {
  padding: 0 12px !important;
}

.text-h6-nystext {
  font-size: 1.25rem !important;
  font-weight: 800;
  /* line-height: 2rem; */
  letter-spacing: 0.0125em !important;
  font-family: "Roboto", sans-serif !important;
}

.text-h6-nolineht {
  font-size: 1.25rem !important;
  font-weight: 500;
  /* line-height: 2rem; */
  letter-spacing: 0.0125em !important;
  font-family: "Roboto", sans-serif !important;
}

.text-h6-nystext-regular {
  font-weight: 500;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  font-size: 0.8em !important;
}

.text-needtoexpand-color {
  color: #b35806 !important;
}

.text-needtoshrink-color {
  color: #1a9850;
}

.hidden .v-tabs-bar {
  display: none;
}

.legend-items .v-tabs-items {
  overflow: visible;
}

.v-slide-group.v-tabs-bar {
  width: 100%;
  position: fixed;
  z-index: 1;
}

.side-menu-container.A .under-sticky {
  margin-top: 50px;
}

.side-menu-container.B .v-text-field__details {
  display: none;
}
</style>
